// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2b25f32b","244":"a04a7924","366":"7cf756db","525":"f00edf11","538":"ee295217","566":"b6c03369","614":"c4022a98","676":"cd332d1d"}[chunkId] + ".chunk.js";
};